// The fixed segments outrank the `marketing/*` catch-all that serves the ad dashboard.
import { Route } from 'react-router-dom';

import { usePermissions } from '../../hooks/usePermissions';
import RequirePermission from '../../shared/RequirePermission';
import { Permission } from '../../types/permissions';

import { NewGiftPassBundleButton } from './components/NewGiftPassBundleButton';
import GiftPassBundleCreatePage from './GiftPassBundleCreatePage';
import GiftPassBundleEditPage from './GiftPassBundleEditPage';
import GiftPassBundlesListPage from './GiftPassBundlesListPage';

/** The list, with "New bundle" and openable rows only for staff who can edit. */
function GiftPassBundlesListRoute() {
  const { hasPermission } = usePermissions();
  return (
    <GiftPassBundlesListPage
      actions={<NewGiftPassBundleButton />}
      canOpenBundles={hasPermission(Permission.WRITE_GIFT_PASS_BUNDLES)}
    />
  );
}

export const giftPassBundlesRoutes = (
  <>
    <Route
      path="marketing/gift-pass-bundles"
      element={
        <RequirePermission permission={Permission.READ_GIFT_PASS_BUNDLES}>
          <GiftPassBundlesListRoute />
        </RequirePermission>
      }
    />
    <Route
      path="marketing/gift-pass-bundles/new"
      element={
        <RequirePermission permission={Permission.WRITE_GIFT_PASS_BUNDLES}>
          <GiftPassBundleCreatePage />
        </RequirePermission>
      }
    />
    <Route
      path="marketing/gift-pass-bundles/:id"
      element={
        <RequirePermission permission={Permission.WRITE_GIFT_PASS_BUNDLES}>
          <GiftPassBundleEditPage />
        </RequirePermission>
      }
    />
  </>
);
